import React from "react";
import classnames from "classnames";

class IconSaveForLater extends React.Component {
    onKitsClick(e) {
        return e.preventDefault();
    }

    render() {
        return (
            <div className="kit-share-container">
                <div className="kit-wrapper">
                    <button
                        onClick={this.onKitsClick.bind(this)}
                        data-icon-id={this.props.icon.id}
                        className="kit button"
                    >
                        Save for Later
                    </button>
                    <div className="kit-container" />
                </div>
            </div>
        );
    }
}

export default IconSaveForLater;
